import { render, staticRenderFns } from "./PageRight.vue?vue&type=template&id=a03959c6&scoped=true&"
import script from "./PageRight.vue?vue&type=script&lang=js&"
export * from "./PageRight.vue?vue&type=script&lang=js&"
import style0 from "./PageRight.vue?vue&type=style&index=0&id=a03959c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03959c6",
  null
  
)

export default component.exports